module.exports = __webpack_public_path__ + "fonts/Times-New-Roman.e2f6bf4e.ttf";